import React, { useRef, useEffect, useCallback, useState} from 'react';
import TrackMidiInputDropdown from "components/settings/TrackMidiInputDropdown.js";
import CheckboxParameter from "components/effects/CheckboxParameter.js";
import {toggleStep} from 'operations/actions.js';
import CirklonAuxEvents from './CirklonAuxEvents.js';
import ChokesAndMatches from 'components/sidebar/ChokesAndMatches.js';
import Bars from './Bars.js';
import TrackFooter from '../v2/TrackFooter.js';
import CirklonStep from './CirklonStep.js';
import {connect} from 'react-redux';
import CirklonParameterChooser from './CirklonParameterChooser.js';
import '../../Cirklon.scss';

const CirklonEditor = ({
    stepIds,
    track,
    steps,
    parameter,
    resolution,
    color
}) => { 
    let [selectedBar, setSelectedBar] = useState(0);
    let [isFollowing, setIsFollowing] = useState(true);
    let [stepDatas, setStepDatas] = useState(stepIds);
    let lastStep = useRef(undefined);
    let barLength = resolution.numSteps();
    if (resolution.resolution === 32) {
        barLength /= 2;
    }
    let start = barLength * selectedBar;
    let end = barLength * (selectedBar + 1);

    useEffect(() => {
        setStepDatas(track.getStepsAtResolution(resolution));
    }, [stepIds, setStepDatas]);

    
    steps = steps ? steps.slice(start, end) : [];

    const onTouchMove = useCallback((e, isStart) => {
        let x=e.touches[0].clientX;
        let y=e.touches[0].clientY;
        let el = document.elementFromPoint(x, y);
        if (el && el.dataset.stepnumber !== undefined) {
            let stepNumber = parseInt(el.dataset.stepnumber);
            if (stepNumber === lastStep.current) {
                return;
            }
            lastStep.current = stepNumber;
            if (isStart) {
                return;
            }
            let className = el.className;
            if (className.includes("step-toggle") || className.includes("cirklon-step")) {
                let stepData = stepDatas[stepNumber];
                track.pattern.clearCache();
                track.sequencerEngine.operationManager.dispatch(
                    toggleStep(track, stepNumber, resolution));
            }
        }
    }, [stepDatas, resolution]);

    if (steps === undefined) {
        return [];
    }
    return (
        <div className="cirklon-editor">
          <div onTouchStart={(e) => onTouchMove(e, true)} onTouchEnd={() => lastStep.current = undefined} onTouchMove={onTouchMove} className="cirklon-steps">
          {steps.map(
              (on, stepNumber) =>
                  <CirklonStep
                    color={color}
                    resolution={resolution}
                    track={track}
                    i={stepNumber}
                    stepNumber={start + stepNumber}
                    key={start+'.'+stepNumber} 
                    stepData={stepDatas[start + stepNumber]}
                    parameter={parameter}
                    on={on}/>)}
          </div>
          <CirklonParameterChooser color={color} stepDatas={stepDatas} track={track}/>
          <ChokesAndMatches sequencerEngine={track.sequencerEngine} track={track}/>
          <CheckboxParameter name="Skip Midi Master" parameter={track.skipMidiMasterParameter}/>
          <TrackMidiInputDropdown
            midiEngine={track.sequencerEngine.midi}
            midiInputs={track.midiInputs}/>
          <TrackFooter track={track} isSelectedTrack={true} trackColor={color}>
            <Bars
              track={track}
              isFollowing={isFollowing}
              setIsFollowing={setIsFollowing}
              numberOfSteps={stepDatas.length}
              barLength={barLength}
              resolution={resolution}
              setSelectedBar={setSelectedBar}
              selectedBar={selectedBar}/>
          </TrackFooter>
        </div>);
}

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    return {
        resolution: state.sequencer.displayResolution,
        stepIds: state.tracks.trackStepIds[props.track.id],
        steps: state.tracks.trackSteps[props.track.id],
        parameter: state.cirklon.cirklonParameterSelected[props.track.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonEditor);
